import { IShop } from "../../store/interfaces/shops";

export const factoryShops = shops => {
  let newShops: IShop[] = [];
  for (let property in shops) {
    newShops.push({
      letter: property,
      merchants: shops[property]["merchants"],
      count: shops[property]["merchantsCount"]
    });
  }
  return newShops;
};
